
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".5","fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.109 5.39a1.135 1.135 0 010-1.606L7.09.803a1.135 1.135 0 011.605 0l2.982 2.981a1.135 1.135 0 01-1.606 1.605L9.028 4.346v9.834a1.135 1.135 0 11-2.27 0V4.346L5.713 5.389a1.135 1.135 0 01-1.605 0z","fill":"currentColor"}})])
          )
        }
      }
    